import { Box, Modal, IconButton, Typography, Button } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

interface LearnerSurveyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const LearnerSurveyModal = ({ isOpen, onClose }: LearnerSurveyModalProps) => {
  return (
    <>
      <Modal
        open={isOpen}
        onClose={onClose}
        aria-label="modal-learner-survey"
        aria-description="A modal informing you that you need to complete a survey."
      >
        <Box sx={{
          position: "relative", backgroundColor: "white", textAlign: "center",
          padding: "2px", width: "470px", height: "320px",
          top: "50%", left: "50%", transform: "translate(-50%, -50%)",
          borderRadius: "12px"
        }}>

          <Box sx={{
            backgroundColor: "white", textAlign: "center",
            padding: "28px", width: "100%", height: "100%",
            border: "2px solid black",
            borderRadius: "12px", display: "flex", flexDirection: "column", justifyContent: "end", alignItems: "center",
          }}>
            <IconButton onClick={onClose} sx={{ position: "absolute", width: "24px", height: "24px", right: "24px", top: "19px"}}>
              <CloseIcon />
            </IconButton>

            <p className="font-semibold mb-[70px]">{"Please complete a short survey about this project. Clicking the link below will open the survey in a new tab."}</p>

            <Button
              sx={{ 
                backgroundColor: "black", height: "32px", width: "165px",
                color: "white", fontSize: "14px", textWrap: "nowrap", borderRadius: "8px"
              }}
              onClick={() => window.open("https://docs.google.com/forms/d/e/1FAIpQLSfW85xUYJWik650c3BCGsR9l7xmBZEwU_UlNSPZLLeVbTLsOg/viewform", "_blank")}
            >
              Start the Survey
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  )
}

export default LearnerSurveyModal;